module.exports = __webpack_public_path__ + "assets/img/cc076ad025960eb6564ba839f2d1ac42.svg";